export const dpr = window.devicePixelRatio || 1;
export const PI = Math.PI;
